<template>
  <div class="slider-pagination" :class="paginationClasses">
    <button v-for="page in pagesCount"
            :key="page"
            class="slider-pagination__dot"
            :class="{ 'slider-pagination__dot--active': page - 1 === currentPage }"
            @click="$emit('page-change', page - 1)"
            :aria-label="`Go to slide ${page}`" />
  </div>
</template>

<script>
export default {
  props: {
    pagesCount: {
      type: Number,
      required: true,
      validator: (value) => value >= 0
    },
    currentPage: {
      type: Number,
      required: true,
      validator: (value) => value >= 0
    },
    orientation: {
      type: String,
      default: 'horizontal',
      validator: (value) => ['horizontal', 'vertical'].includes(value)
    }
  },
  computed: {
    paginationClasses() {
      return {
        'slider-pagination--horizontal': this.orientation === 'horizontal',
        'slider-pagination--vertical': this.orientation === 'vertical'
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.slider-pagination {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  z-index: 1;

  &--horizontal {
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
    gap: 32px;
  }

  &--vertical {
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    flex-direction: column;
    gap: 8px;
  }

  &__dot {
    width: 170px;
    height: 3px;
    border-radius: 1.5px;
    border: none;
    background-color: #CADDFC;
    padding: 0;
    transition: width 300ms ease-in-out, background-color 300ms ease-in-out;
    cursor: pointer;

    &--active {
      width: 270px;
      background-color: #6171E4;
    }

    &:focus {
      outline: none;
    }
  }
}
</style>
